import { render, staticRenderFns } from "./D108.vue?vue&type=template&id=509417b0&scoped=true"
import script from "./D108.vue?vue&type=script&lang=js"
export * from "./D108.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=509417b0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509417b0",
  null
  
)

export default component.exports